import { Routes } from '@angular/router';
import {AuthGuard} from '@auth0/auth0-angular';;
import { WebhooksEventsGuard } from '../core/guards/webhooks-events.guard';
import { WebhooksEventsComponent } from './webhooks-events.component';
import { WebhookPendingSubscriptionChangesGuard } from './guards/webhook-pending-subscription-changes.guard';

export const WEBHOOKS_EVENTS_ROUTES: Routes = [
  {
    path: 'webhooks-events', canActivate: [AuthGuard, WebhooksEventsGuard], canDeactivate: [WebhookPendingSubscriptionChangesGuard],
    children: [
      { path: '', component: WebhooksEventsComponent, data: { mode: 'list' } },
      { path: 'details/:id', component: WebhooksEventsComponent, data: { mode: 'details' } },
      { path: 'config', component: WebhooksEventsComponent, data: { mode: 'config' } },
      { path: 'doc', component: WebhooksEventsComponent, data: { mode: 'doc' } },
    ]
  },
];
